import { render, staticRenderFns } from "./deliverystatusreport_mr.vue?vue&type=template&id=e33bcf8e"
import script from "./deliverystatusreport_mr.vue?vue&type=script&lang=js"
export * from "./deliverystatusreport_mr.vue?vue&type=script&lang=js"
import style0 from "./deliverystatusreport_mr.vue?vue&type=style&index=0&id=e33bcf8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports